import type { LabelHTMLAttributes } from 'react';
import { cn } from './cn.js';

export function Label({ className, ...rest }: LabelHTMLAttributes<HTMLLabelElement>) {
  return (
    <label
      {...rest}
      className={cn(
        'block text-[11px] font-medium uppercase tracking-wider text-text-muted mb-2',
        className,
      )}
    />
  );
}
